import { Axios } from "../axios";

export type CkycPublicData = {
  mhAccessToken?: string;
  uniqueKey?: string;
  completed?: boolean;
  journeyId?: number;
  message?: string | null;
  hypervergeDlAccessTokenExpired?: boolean;
  hypervergeDlAccessTokenExpiryAt?: string | null;
  valid?: boolean;
  mhAccessTokenExpiryAt?: string | null;
  success?: boolean;
  appId?: string;
  name?: string;
  appKey?: string;
  hypervergeDlAccessToken?: string | null;
  authToken?: string | null;
  id?: number;
  ckycTransactionId?: string;
  workflowId?: string;
  mhLinkExpired?: boolean;
  status?: string;
};

export type CkycSessionData = {
  mhAccessToken?: string;
  uniqueKey?: string;
  authToken?: string | null;
  hypervergeDlAccessToken?: string | null;
  id?: number;
  journeyId?: number;
  hypervergeDlAccessTokenExpired?: boolean;
  ckycTransactionId?: string;
  workflowId?: string;
  expirySeconds?: number;
  hypervergeDlAccessTokenExpiryAt?: string | null;
};

const publicHeaders = {
  "Content-Type": "application/json",
};

const unwrapCkycPayload = (response: any): any => {
  const raw = response?.data ?? response;
  if (!raw || typeof raw !== "object") return null;

  if (typeof raw.body === "string") {
    try {
      const parsed = JSON.parse(raw.body);
      return parsed?.data ?? parsed;
    } catch {
      return null;
    }
  }

  if (raw.data && typeof raw.data === "object" && !raw.mhAccessToken && !raw.workflowId) {
    return raw.data;
  }

  return raw;
};

export const ckycApi = {
  async getPublicCkyc(token: string) {
    return await Axios.get(`/remit/kyc/ckyc/public/${token}`, {
      headers: publicHeaders,
    });
  },

  async createSession(mhAccessToken: string) {
    return await Axios.post(
      `/remit/kyc/ckyc/session`,
      { mhAccessToken },
      { headers: publicHeaders }
    );
  },
};

export const parseCkycPublicResponse = (response: any): CkycPublicData | null => {
  const data = unwrapCkycPayload(response);
  if (!data || typeof data !== "object") return null;
  return data as CkycPublicData;
};

export const parseCkycSessionResponse = (response: any): CkycSessionData | null => {
  const data = unwrapCkycPayload(response);
  if (!data || typeof data !== "object") return null;
  return data as CkycSessionData;
};

export const stripBearerToken = (token?: string | null) =>
  String(token || "")
    .replace(/^Bearer\s+/i, "")
    .trim();

export const needsCkycSessionRefresh = (data?: CkycPublicData | CkycSessionData | null) =>
  !stripBearerToken(data?.hypervergeDlAccessToken) || Boolean(data?.hypervergeDlAccessTokenExpired);
